<template>
	<div>
		<el-card>
			<div class="flex flex-wrap">
				<div v-for="(item,index) in classifyList" :key="index" class="classify-item" :class="classifyIndex == index ? 'col-169' : 'col-333'">{{item.name}}</div>
			</div>
			<div class="flex align-c">
				<div class="classify-menu flex align-c justify-c">
					<el-dropdown>
					  <span class="el-dropdown-link col-333">
					    工作城市<i class="el-icon-arrow-down el-icon--right"></i>
					  </span>
					  <el-dropdown-menu slot="dropdown">
					    <el-dropdown-item>厦门</el-dropdown-item>
					    <el-dropdown-item class="col-169">福州</el-dropdown-item>
					    <el-dropdown-item>泉州</el-dropdown-item>
					  </el-dropdown-menu>
					</el-dropdown>
				</div>
				<div class="classify-menu flex align-c justify-c">
					<el-dropdown>
					  <span class="el-dropdown-link col-333">
					    工作经验<i class="el-icon-arrow-down el-icon--right"></i>
					  </span>
					  <el-dropdown-menu slot="dropdown">
					    <el-dropdown-item>不限</el-dropdown-item>
					    <el-dropdown-item>在校生</el-dropdown-item>
					    <el-dropdown-item>应届生</el-dropdown-item>
					  </el-dropdown-menu>
					</el-dropdown>
				</div>
				<div class="classify-menu flex align-c justify-c">
					<el-dropdown>
					  <span class="el-dropdown-link col-333">
					    学历要求<i class="el-icon-arrow-down el-icon--right"></i>
					  </span>
					  <el-dropdown-menu slot="dropdown">
					    <el-dropdown-item>不限</el-dropdown-item>
					    <el-dropdown-item>大专</el-dropdown-item>
					    <el-dropdown-item>本科</el-dropdown-item>
					  </el-dropdown-menu>
					</el-dropdown>
				</div>
				<div class="classify-menu flex align-c justify-c">
					<el-dropdown>
					  <span class="el-dropdown-link col-333">
					    薪资待遇<i class="el-icon-arrow-down el-icon--right"></i>
					  </span>
					  <el-dropdown-menu slot="dropdown">
					    <el-dropdown-item>不限</el-dropdown-item>
					    <el-dropdown-item>3k</el-dropdown-item>
					    <el-dropdown-item>6k</el-dropdown-item>
					  </el-dropdown-menu>
					</el-dropdown>
				</div>
				<div class="classify-menu flex align-c justify-c">
					<div class="classify-input">
						<el-input v-model="keyWord" placeholder="搜索职位中包含的关键词"></el-input>
					</div>
					<el-image class="classify-img" :src="require('@/assets/images/job/search@2x.png')"></el-image>
				</div>
			</div>
		</el-card>
		<el-row :gutter="20" class="mt-20">
			<el-col :span="7">
				<div class="resumei-list">
					<div class="resumei-item bg-fff" v-for="(item,index) in resumeiList" :key="index" :class="resumeiIndex == index?'resumei-active':''" @click="resumeiChange(item,index)">
						<div class="resumei-title flex align-c justify-sb bold">
							<div class="title-title col-333">高级服装产品专员</div>
							<div class="title-price">{{index+1}}-15K</div>
						</div>
						<div class="flex align-c plr-20">
							<div class="resumei-label flex align-c justify-c">{{index+1}}年</div>
							<div class="resumei-label flex align-c justify-c">{{index%2==0?'大专':'本科'}}</div>
						</div>
						<div class="resumei-msg flex align-c justify-sb">
							<div class="flex align-c">
								<div class="msg-hr">
									<el-image class="hr-img"
										:src="require('@/assets/images/nav/tx-n.png')"></el-image>
									<div class="hr-circle" v-if="resumeiIndex == index"></div>
								</div>
								<div class="msg-font col-666">何{{index%2==0?'女士':'先生'}}·资深招聘</div>
							</div>
							<div class="msg-font col-666">厦门</div>
						</div>
					</div>
				</div>
				<div class="resumei-page">
					<el-pagination
					  background
					  layout="prev, pager, next" :pager-count="5"
					  :total="1000">
					</el-pagination>
				</div>
			</el-col>
			<el-col :span="17" class="resume">
				<el-card>
					<div class="detail-title flex align-c justify-sb">
						<div>
							<div class="flex align-c">
								<div class="de-title col-333 bold">高级服装产品专员</div>
								<div class="de-price bold">{{resumeiIndex+1}}-15K</div>
							</div>
							<div class="flex align-c mt-17">
								<el-image class="de-icon"
									:src="require('@/assets/images/job/positioning@2x.png')"></el-image>
								<div class="de-sub col-333">厦门</div>
								<el-image class="de-icon"
									:src="require('@/assets/images/job/time@2x.png')"></el-image>
								<div class="de-sub col-333">{{resumeiIndex+1}}年</div>
								<el-image class="de-icon"
									:src="require('@/assets/images/job/education@2x.png')"></el-image>
								<div class="de-sub col-333">{{resumeiIndex%2==0?'大专':'本科'}}</div>
							</div>
						</div>
						<div class="flex align-c">
							<div class="de-btn1 flex align-c justify-c">课程查看</div>
							<div class="de-btn2 flex align-c justify-c col-fff">简历投递</div>
						</div>
					</div>
					<div class="col-333 bold de-describe">职位描述：</div>
					<div class="flex align-c col-333">
						<div class="de-label flex align-c">
							市场调研
						</div>
						<div class="de-label flex align-c">
							产品规划
						</div>
					</div>
					<div class="de-ask col-333">
						<div>1.制定服配系列产品策划</div>
						<div>  参与制定所负责服装系列的产品风格、产品线规划、产品结构、产品生命周期、价格体系、上市期、服配鞋产品搭配等；</div>
						<div>2.进行市场调研和资讯分析</div>
						<div>  进行市场调研和资讯分析，预估市场容量、订货与销售数据，并制定策略方案，确保负责的服装产品各项业务目标的达成；</div>
						<div>3.制定服配产品策划案</div>
						<div>  制定负责系列的产品策划案，确保产品策划案的合理性和准时交付；</div>
						<div>4.服配产品调整</div>
						<div>  参加评审会、预览会及订货会，对异常提出即时整改的要求；</div>
						<div>  负责本系列服装产品订货业绩及各项生意指标的达成，根据产品的订货和销售状况，对本品类/系列产品进行总结、评估，</div>
						<div>  提出后续调整和改进的方案，并发现新的业绩增长机会；</div>
						<div>  关注销售渠道和生产的状况，结合本系列服装产品策划案，合理安排、调整本系列服装产品的上市期；</div>
						<div>  积极关注全球服饰行业动态，发现新的生意增长机会，同时为本品牌的服装产品力提升、调整和必要的改变</div>
					</div>
					<div class="flex align-c justify-c de-hit col-fff">
						注意：该岗位需相关技能达到炉火纯青阶段考
					</div>
					<div class="de-staff flex align-c">
						<el-image class="staff-img"
							:src="require('@/assets/images/nav/tx-n.png')"></el-image>
						<div>
							<div class="flex align-c">
								<div class="col-333 bold staff-name">何{{resumeiIndex%2==0?'女士':'先生'}}</div>
								<div class="staff-day col-666">{{resumeiIndex+1}}天内活跃</div>
							</div>
							<div class="staff-day col-666 mt-3">鸿星尔克·资深招聘</div>
						</div>
					</div>
					<div class="col-333 bold de-describe">
						工作地点：
					</div>
					<div class="flex align-c mt-20">
						<el-image class="de-icon"
							:src="require('@/assets/images/job/positioning@2x.png')"></el-image>
						<div class="col-333 address-title">厦门思明区鸿星尔克集团大厦19楼</div>
					</div>
					<el-image class="address-map"
						:src="require('@/assets/images/job/dt@2x.png')"></el-image>
					<div class="resume-more flex align-c justify-c">查看更多信息</div>
				</el-card>
			</el-col>
		</el-row>
		<div class="handpick">
			<el-card>
				<div class="flex align-c justify-sb">
					<div class="handpick-title col-333 bold">精选职位</div>
					<div class="flex align-c">
						<div class="handpick-more">查看更多职位</div>
						<el-image class="handpick-icon"
							:src="require('@/assets/images/job/drop-down@2x.png')"></el-image>
					</div>
				</div>
				<div class="handpick-list flex flex-wrap">
					<div class="handpick-item" v-for="(item,index) in handpickList" :key="index">
						<div class="flex align-c justify-sb">
							<div class="col-333 bold handpick-item-title over-1">产品主管专员、测试员、技术人员</div>
							<div class="handpick-price bold">8-11K·14薪</div>
						</div>
						<div class="flex align-c justify-sb mt-20">
							<div class="flex align-c">
								<el-image class="handpick-img"
									:src="require('@/assets/images/index/hxek.png')"></el-image>
								<div class="handpick-brand">鸿星尔克</div>
							</div>
							<div class="handpick-brand">厦门</div>
						</div>
					</div>
				</div>
			</el-card>
		</div>
		<div class="job-breadcrumb flex align-c">
			<el-image class="breadcrumb-home"
				:src="require('@/assets/images/job/home@2x.png')"></el-image>
			<el-breadcrumb separator="|">
			  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			  <el-breadcrumb-item><a href="/job">岗位需求</a></el-breadcrumb-item>
			  <el-breadcrumb-item>鸿星尔克</el-breadcrumb-item>
			  <el-breadcrumb-item>鸿星尔克招聘</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				classifyList:[
					{name:'全部(91)'},{name:'设计(20)'},{name:'运营(15)'},{name:'采购/贸易(12)'},{name:'服务业(9)'},
					{name:'技术(8)'},{name:'人力/财务/行政(7)'},{name:'销售(5)'},{name:'产品(5)'},{name:'传媒(3)'},{name:'生产制造(1)'},
				],
				classifyIndex:0,
				keyWord:'',
				resumeiList:[{},{},{},{},{},{},{},{},{},{},{},{}],
				resumeiIndex:0,
				handpickList:[{},{},{},{},{},{},{},{}]
			}
		},
		mounted() {
			
		},
		methods:{
			resumeiChange(item,index){
				this.resumeiIndex = index
			},
		}
	}
</script>

<style>
	.classify-item{
		margin: 0 44px 20px 0;
		font-size: 16px;
		line-height: 22px;
		cursor: pointer;
	}
	.col-169{
		color: #169BD5;
	}
	.classify-item:hover{
		color: #169BD5;
	}
	.classify-menu{
		padding: 0 10px;
		height: 34px;
		border-radius: 8px;
		background: #F8F8F8;
		margin-right: 16px;
	}
	.classify-menu:hover{
		/* background: #169BD5; */
	}
	.classify-menu .el-dropdown-link{
		font-size: 16px;
	}
	.el-dropdown-menu__item{
		padding: 0 30px;
	}
	.classify-img{
		width: 16px;
		height: 16px;
		cursor: pointer;
	}
	.classify-input{
		width: 180px;
		margin-right: 10px;
	}
	.classify-input .el-input__inner{
		padding: 0;
		border: none;
		background: transparent;
		height: 30px;
	}
	.mt-20{
		margin-top: 20px;
	}
	.resume .el-card{
		border-radius: 12px;
		height: 1016px;
		overflow-y: scroll;
	}
	.resumei-list{
		height: 936px;
		overflow-y: scroll;
	}
	.resumei-list::-webkit-scrollbar,.resume .el-card::-webkit-scrollbar {
		display: none;
	}
	.resumei-item{
		height: 136px;
		box-shadow: 0px 3px 6px 0px rgba(0,55,98,0.2);
		border-radius: 12px;
		margin-bottom: 20px;
		overflow: hidden;
		position: relative;
		cursor: pointer;
	}
	.resumei-active{
		border: 2px solid #169BD5;
	}
	.resumei-title{
		padding: 16px 20px 8px 20px;
	}
	.title-title{
		font-size: 18px;
		line-height: 25px;
	}
	.title-price{
		font-size: 16px;
		line-height: 22px;
		color: #FE574A;
	}
	.resumei-label{
		height: 26px;
		margin-right: 6px;
		border-radius: 2px;
		background: #F8F8F8;
		padding: 0 16px;
	}
	.plr-20{
		padding: 0 20px;
	}
	.resumei-msg{
		height: 48px;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
		width: 100%;
		background: linear-gradient(270deg, #F9F9F8 0%, #F5FCFC 100%);
		padding: 0 20px;
	}
	.msg-font{
		font-size: 12px;
		line-height: 17px;
	}
	.msg-hr{
		position: relative;
		margin-right: 10px;
	}
	.hr-circle{
		position: absolute;
		width: 10px;
		height: 10px;
		border-radius: 50%;
		right: 0;
		bottom: 2px;
		background: #07E06C;
	}
	.hr-img{
		width: 26px;
		height: 26px;
		border-radius: 50%;
	}
	.resumei-page{
		margin-top: 48px;
	}
	.resumei-page .el-pagination{
		padding: 0;
	}
	.resumei-page .el-pagination.is-background .el-pager li,
	.resumei-page .el-pagination.is-background .btn-prev,
	.resumei-page .el-pagination.is-background .btn-next
	{
		background: #fff;
	}
	.de-title{
		font-size: 18px;
		line-height: 25px;
	}
	.de-price{
		font-size: 24px;
		line-height: 33px;
		color: #FE574A;
		margin-left: 22px;
	}
	.de-icon{
		width: 16px;
		height: 16px;
		margin-right: 6px;
	}
	.mt-17{
		margin-top: 17px;
	}
	.de-sub{
		font-size: 14px;
		line-height: 20px;
		margin-right: 24px;
	}
	.de-btn1{
		width: 110px;
		height: 38px;
		margin-right: 12px;
		border-radius: 8px;
		border: 1px solid #169BD5;
		color: #169BD5;
		font-size: 14px;
	}
	.de-btn2{
		width: 110px;
		height: 38px;
		background: #169BD5;
		font-size: 14px;
		border-radius: 8px;
	}
	.de-describe{
		font-size: 16px;
		line-height: 22px;
		margin-top: 26px;
	}
	.de-label{
		height: 30px;
		margin-top: 16px;
		border-radius: 2px;
		background: #F8F8F8;
		padding: 0 10px;
		margin-right: 8px;
		font-size: 13px;
	}
	.de-ask{
		margin-top: 26px;
		line-height: 22px;
		font-size: 14px;
	}
	.de-hit{
		margin-top: 20px;
		height: 36px;
		border-radius: 8px;
		background: rgba(130,1,1,0.67);
		font-size: 14px;
		line-height: 20px;
	}
	.de-staff{
		height: 80px;
		margin-top: 26px;
		border-bottom: 1px solid #EDEDED;
		border-top: 1px solid #EDEDED;
	}
	.staff-img{
		width: 42px;
		height: 42px;
		border-radius: 50%;
		margin-right: 10px;
	}
	.staff-name{
		font-size: 16px;
		line-height: 22px;
		margin-right: 26px;
	}
	.staff-day{
		font-size: 12px;
		line-height: 17px;
	}
	.mt-3{
		margin-top: 3px;
	}
	.address-title{
		font-size: 16px;
		line-height: 22px;
	}
	.resume-more{
		width: 260px;
		height: 56px;
		border-radius: 8px;
		border: 1px solid #169BD5;
		margin: auto;
		margin-top: 26px;
		font-size: 16px;
		line-height: 22px;
		color: #169BD5;
	}
	.address-map{
		margin-top: 10px;
		height: 159px;
		border-radius: 12px;
	}
	.handpick{
		margin-top: 36px;
	}
	.handpick .el-card{
		border-radius: 12px;
		max-height: 290px;
	}
	.handpick-icon{
		width: 6px;
		height: 8px;
		margin-left: 12px;
	}
	.handpick-more{
		font-size: 14px;
		color: #169BD5;
		line-height: 20px;
	}
	.handpick-title{
		font-size: 18px;
		line-height: 25px;
	}
	.handpick-list{
		padding-top: 6px;
	}
	.handpick-item{
		margin: 12px 12px 0 0;
		height: 94px;
		border-radius: 8px;
		border: 1px solid #EDEDED;
		width: 290px;
		padding: 16px;
	}
	.handpick-item:nth-child(4n){
		margin-right: 0;
	}
	.handpick-item-title{
		font-size: 16px;
		line-height: 22px;
		width: 160px;
	}
	.handpick-price{
		font-size: 16px;
		line-height: 22px;
		color: #FE574A;
	}
	.handpick-img{
		width: 24px;
		height: 24px;
		border-radius: 4px;
		margin-right: 10px;
	}
	.handpick-brand{
		font-size: 14px;
		color: #6F6F6F;
		line-height: 20px;
	}
	.job-breadcrumb{
		height: 92px;
	}
	.breadcrumb-home{
		width: 16px;
		height: 16px;
		margin-right: 12px;
	}
</style>